var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    transform: "translate(405 187)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-405 -187)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(405 187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,13.5v3.865l-4.532,5.062c-1.142.813-2.641,1.818-3.874,1.151l-8.041-7.128L50.6,11.77A1.828,1.828,0,0,1,53,13.5Z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.092,25.358l-.11.228L21.977,28.922a5.381,5.381,0,0,0-1.736.959l-9.275,7.584L24.52,49.345c.932.6,7.935-.71,8.986-1.066l11.879-6.091c1.1-.366,3.29-2.1,3.655-3.2l.3-4.265c.786-2.367-1.159-2.741-3.655-2.741l-2.523-2.089m-5.93.947-3.189-3.189m5.373,4.971h-.009",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,46.6V53H34.724l3.107-4.4a3.725,3.725,0,0,1,1.636-1.636l5.693-2.842c1.407-.7,4.934-4.085,6.049-2.97Z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.414,53H0v-.521a4.559,4.559,0,0,1,2.933-4.258l8.946-3.445Z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,17.362V46.6l-1.791-1.791a3.655,3.655,0,0,0-4.222-.685l-5.693,2.842A3.725,3.725,0,0,0,39.659,48.6L37.466,53H23.759L11.879,44.776l-.914-7.31,14.063,9.1a3.621,3.621,0,0,0,3.134.393L43.953,41.7a3.641,3.641,0,0,0,2.312-2.312l.567-1.681A3.655,3.655,0,0,0,43.359,32.9h-.841c.064-.073.128-.137.192-.2a5.4,5.4,0,0,1,2.906-1.517.091.091,0,0,0,0-.174,5.349,5.349,0,0,1-2.906-1.526,5.411,5.411,0,0,1-1.526-2.906.091.091,0,0,0-.174,0,5.47,5.47,0,0,1-3.774,4.267l-5.254-5.254c.877-2.367,2.888-2.6,2.33-4.669l2.239-4.468,8.041,4.386a3.664,3.664,0,0,0,3.874-.238Z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.678,5.824l1.934-1.935a1.828,1.828,0,0,1,2.584,0l.64.64a1.828,1.828,0,0,1,0,2.584L28.9,9.047l-7.26,7.265L3.893,34.059A2.284,2.284,0,0,1,.665,30.831L18.413,13.084Z",
    fill: "#cb8252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.048,27.651c-.091.256-.192.5-.311.758a21.383,21.383,0,0,0-1.645-3.052,66.877,66.877,0,0,0-8.032-9.851l-.4-5.17,4.433,1.131s4.788,3.993,6.223,9.449A10.9,10.9,0,0,1,34.048,27.651Z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.617,31.179A5.4,5.4,0,0,0,42.711,32.7c-.064.064-.128.128-.192.2a5.409,5.409,0,0,0-1.334,2.7.091.091,0,0,1-.174,0A5.4,5.4,0,0,0,39.494,32.7l-.073-.073h-.009a5.408,5.408,0,0,0-2.824-1.444.091.091,0,0,1,0-.174,3.97,3.97,0,0,0,.649-.164,5.47,5.47,0,0,0,3.774-4.267.091.091,0,0,1,.174,0,5.411,5.411,0,0,0,1.526,2.906A5.349,5.349,0,0,0,45.617,31a.091.091,0,0,1,0,.174Z",
    fill: "#f9eab0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.565,36.661a5.4,5.4,0,0,0-2.906,1.517,5.476,5.476,0,0,0-1.526,2.906.091.091,0,0,1-.174,0,5.4,5.4,0,0,0-1.517-2.906,5.463,5.463,0,0,0-2.906-1.517.091.091,0,0,1,0-.174,5.483,5.483,0,0,0,4.423-4.432.091.091,0,0,1,.174,0,5.411,5.411,0,0,0,1.526,2.906,5.349,5.349,0,0,0,2.906,1.526.091.091,0,0,1,0,.174Z",
    fill: "#f3d55b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.312.983C11.96,3.4,19.22,10.664,19.22,10.664l4.437.4-.4-4.436S15.186-3.05,6.312.983Z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.845,
    height: 10.267,
    rx: 0.914,
    transform: "translate(24.867 5.017) rotate(45)",
    fill: "#7f8c8d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMine);
export default __webpack_public_path__ + "static/media/mine.7a89b295818082ea8e35c89a7cf094b1.svg";
export { ForwardRef as ReactComponent };